"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConfigurationType = void 0;
let ConfigurationType = exports.ConfigurationType = /*#__PURE__*/function (ConfigurationType) {
  ConfigurationType["Authentication"] = "AUTHENTICATION";
  ConfigurationType["Common"] = "COMMON";
  ConfigurationType["Hierarchy"] = "HIERARCHY";
  ConfigurationType["Messaging"] = "MESSAGING";
  ConfigurationType["Url"] = "URL";
  return ConfigurationType;
}({});
